// src/components/SuperAdminSubscriptions/SuperAdminSubscriptionsMobile.jsx
import React, { useEffect, useState, useContext } from "react";
import {
  collectionGroup,
  query,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";

import {
  Box,
  Typography,
  Paper,
  List,
  ListItemText,
  Button,
  CircularProgress,
} from "@mui/material";
import { LanguageContext } from "../context/LanguageContext";
import MobileHeader from "./headers/MobileHearder";
import { db } from "../firebase";

export default function SuperAdminSubscriptionsMobile() {
  const { translate } = useContext(LanguageContext);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loadingCancel, setLoadingCancel] = useState(null);

  useEffect(() => {
    const subsQuery = query(collectionGroup(db, "subscriptions"));
    const unsub = onSnapshot(subsQuery, (snap) => {
      setSubscriptions(
        snap.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
          ref: docSnap.ref,
        }))
      );
    });
    return () => unsub();
  }, []);

  const handleCancel = async (sub) => {
    if (!window.confirm(translate("ConfirmCancelSubscription"))) return;
    setLoadingCancel(sub.id);
    try {
      await updateDoc(sub.ref, { cancel_at_period_end: true });
    } finally {
      setLoadingCancel(null);
    }
  };

  return (
    <Box
      p={0}
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        <MobileHeader
          title={translate("AllSubscriptions")}
          showProfileItem={false}
        />
      </Box>

      <Box p={2}>
        <List>
          {subscriptions.map((sub) => (
            <Paper
              key={sub.ref.path}
              variant="outlined"
              sx={{
                my: 1,
                p: 2,
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
                gap: 1,
                bgcolor: "background.paper",
                borderColor: "divider",
              }}
            >
              <ListItemText
                primary={`${translate("Subscription")} #${sub.id}`}
                primaryTypographyProps={{
                  color: "text.primary",
                  variant: "subtitle1",
                }}
                secondary={
                  <>
                    <div>
                      {translate("Customer")}: {sub.customerId}
                    </div>
                    <div>
                      {translate("Status")}: {sub.status}
                    </div>
                    {sub.price && (
                      <div>
                        {translate("Price")}:{" "}
                        {(sub.price.unit_amount / 100).toFixed(2)}/
                        {sub.price.interval}
                      </div>
                    )}
                    <div>
                      {translate("CreatedAt")}:{" "}
                      {new Date(sub.created * 1000).toLocaleString()}
                    </div>
                    {sub.cancel_at_period_end && (
                      <Typography
                        variant="body2"
                        sx={{ color: "warning.main" }}
                      >
                        {translate("CancelScheduled")}
                      </Typography>
                    )}
                  </>
                }
                secondaryTypographyProps={{ color: "text.secondary" }}
              />
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={() => handleCancel(sub)}
                disabled={
                  loadingCancel === sub.id || !!sub.cancel_at_period_end
                }
                sx={{ alignSelf: "flex-end" }}
              >
                {loadingCancel === sub.id ? (
                  <CircularProgress size={18} />
                ) : sub.cancel_at_period_end ? (
                  translate("CancelScheduled")
                ) : (
                  translate("CancelNow")
                )}
              </Button>
            </Paper>
          ))}
        </List>
      </Box>
    </Box>
  );
}
